export default function galleryOpenReducer(state = false, action) {
  switch (action.type) {
    case 'SET_GALLERY_OPEN':
      return action.payload
    default:
      return state
  }
}
